import { Tooltip } from "@alpacahq/ui";
import { clsx } from "@alpacahq/ui/old";

import { STATUS_CONFIG } from "~/v2/components/AssetTradingStatusBadge";

interface SymbolInfoProps {
  symbol: string;
  name: string;
  price: string;
  priceChange: {
    value: number;
    percentage?: string;
  };
  showOvernightNotSupported?: boolean;
  showOvernightHalted?: boolean;
  showNotTradable?: boolean;
}

export const SymbolInfo = ({
  symbol,
  name,
  price,
  priceChange,
  showOvernightNotSupported,
  showOvernightHalted,
  showNotTradable,
}: SymbolInfoProps) => (
  <div className="flex flex-col gap-0.5">
    <div className="flex items-center justify-between gap-1">
      <div className="flex shrink-0 items-center gap-2">
        <h3 className="m-0 p-0 font-bold text-base text-gray-700 leading-[22px]">
          {symbol}
        </h3>
        {showOvernightNotSupported && (
          <Tooltip content={STATUS_CONFIG.overnight_not_supported.message}>
            <STATUS_CONFIG.overnight_not_supported.icon
              size={20}
              className="text-gray-500"
            />
          </Tooltip>
        )}
        {showOvernightHalted && (
          <Tooltip content={STATUS_CONFIG.overnight_halted.message}>
            <STATUS_CONFIG.overnight_halted.icon
              size={20}
              className="text-gray-500"
            />
          </Tooltip>
        )}
        {showNotTradable && (
          <Tooltip content={STATUS_CONFIG.not_tradable.message}>
            <STATUS_CONFIG.not_tradable.icon
              size={20}
              className="text-gray-500"
            />
          </Tooltip>
        )}
      </div>
      <p className="m-0 min-w-0 break-all p-0 text-right font-medium font-mono text-gray-800 text-sm">
        {price}
      </p>
    </div>
    <div className="flex items-start justify-between gap-1">
      <p className="m-0 shrink-0 p-0 text-gray-600 text-xs">{name}</p>
      {priceChange.percentage && (
        <p
          className={clsx(
            "m-0 p-0 font-mono text-xs",
            priceChange.value >= 0 ? "text-emerald-600" : "text-red-500",
          )}
        >
          {priceChange.percentage}
        </p>
      )}
    </div>
  </div>
);
